
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component
export default class ErrorBar extends Vue {
	get errorText() {
		return this.$store.state.login.errorText;
	}
}
